import React, { useState } from 'react';
import { CheckBox, LabeledInput, MultipleSelect, SelectInput } from '../../../Components';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ImageIcon from '@material-ui/icons/Image';

import './Style.css';
import { Pricing } from '../..';
const Index = ({ mode = 'add' }) => {
    const [category, setCategory] = useState('halfsleeve');
    const [name, setname] = useState('');
    const [printTypes, setPrintTypes] = useState([]);
    const [addCate, setAddCate] = useState(false);
    const [newCate, setNewCate] = useState('');
    const [description, setDescription] = useState('');
    const [addImage, setAddImage] = useState(false);
    const [newImage, setNewImage] = useState('');
    const [edit, setEdit] = useState();
    const [categoryoptions, setOptions] = useState([
        { name: 'Full Sleeve', value: 'fullsleeve' },
        { name: 'Half Sleeve', value: 'halfsleeve' },
    ]);
    const [imagesTypes, setImagesType] = useState({
        productFrontSide: {
            name: 'Product Front Side',
            value: '',
        },
        productBackSide: {
            name: 'Product Back Side',
            value: '',
        },
        productSleeve: {
            name: 'Product Sleeve',
            value: '',
        },
    });
    const [sizes, setSizes] = useState('S | M | L');

    const [sizesDescription, setSizesDescrption] = useState({});

    const [typesOfMaterial, setTypeOfMaterial] = useState([]);

    const freeFlowTextHandler = (e) => {
        let newValue = e.target.value;
        if (newValue.endsWith('| ')) {
            newValue = newValue.slice(0, newValue.length - 3);
        } else if (newValue.endsWith('|') && sizes.endsWith(' ')) {
            newValue = newValue.slice(0, newValue.length - 2);
        } else if (sizes.endsWith(' ') && newValue.endsWith(' ')) {
            newValue = sizes;
        } else if (newValue.endsWith(' ')) {
            newValue += '| ';
        }
        setSizes(newValue);
    };

    const materialCheckhandler = (name, currentState) => {
        if (currentState === false) {
            setTypeOfMaterial((prev) => [...prev, name]);
        } else {
            setTypeOfMaterial((prev) => {
                const old = [...prev];
                const index = old.findIndex((ele) => ele === name);
                if (index !== -1) {
                    setSizesDescrption((prev) => {
                        const oldDes = { ...prev };
                        Object.keys(oldDes).forEach((ele) => {
                            oldDes[ele].forEach((color) => {
                                delete color.material[old[index]];
                            });
                        });
                        return oldDes;
                    });
                    old.splice(index, 1);
                }
                return old;
            });
        }
    };

    const imageChangehandler = (type, newValue) => {
        setImagesType((prev) => {
            const old = { ...prev };
            old[type].value = newValue;
            return old;
        });
    };

    const onConfirmSizeHandler = () => {
        const sizeTypes = sizes.trim().endsWith('|')
            ? sizes
                  .trim()
                  .slice(0, sizes.trim().length - 3)
                  .split(' | ')
            : sizes.trim().split(' | ');
        const newSizesTypes = {};
        sizeTypes.forEach((ele) => {
            newSizesTypes[ele] = [
                {
                    color: '#000',
                    material: {},
                },
            ];
        });
        setSizesDescrption(newSizesTypes);
    };

    const onSizeDescrioptionChange = (sizeType, elementNumber, property, newValue, materialalt) => {
        setSizesDescrption((prev) => {
            const old = { ...prev };
            switch (property) {
                case 'color':
                    old[sizeType][elementNumber].color = newValue;
                    break;
                case 'qty':
                    if ((!isNaN(parseInt(newValue)) && newValue >= 0) || newValue === '') {
                        old[sizeType][elementNumber].material[materialalt].units = newValue;
                    }
                    break;
                case 'material':
                    Object.keys(old[sizeType][elementNumber].material).forEach((ele) => {
                        if (newValue.findIndex((val) => val === ele) === -1) {
                            delete old[sizeType][elementNumber].material[ele];
                        }
                    });
                    newValue.forEach((ele) => {
                        if (!old[sizeType][elementNumber].material[ele]) {
                            old[sizeType][elementNumber].material[ele] = { units: 0, price: '' };
                        }
                    });

                    break;
                case 'price':
                    if ((!isNaN(parseInt(newValue)) && newValue >= 0) || newValue === '') {
                        old[sizeType][elementNumber].material[materialalt].price = newValue;
                    }
                    break;
                default:
                    break;
            }
            return old;
        });
    };
    const handleAddMore = (sizeType) => {
        setSizesDescrption((prev) => {
            const old = { ...prev };
            old[sizeType] = [
                ...old[sizeType],
                {
                    color: '#000',

                    material: {},
                },
            ];
            return old;
        });
    };

    return (
        <div className="add_product">
            <div className="add_product_head">
                <h2>{mode === 'edit' ? 'Edit Product' : 'Add Product'}</h2>
            </div>
            <div className="add_product_body">
                <div className="home_head">
                    <h2 className="home_heading">Enter Product Details</h2>
                </div>
                <div className="add_product_container">
                    <div className="add_product_container_categorydetails">
                        <div>
                            <SelectInput
                                label="Select Category"
                                outlined={true}
                                value={category}
                                changeHandler={(e) => {
                                    setCategory(e.target.value);
                                }}
                                options={[...categoryoptions]}
                            />
                            <div className="addnew_category">
                                {addCate && (
                                    <LabeledInput
                                        name="Category Name"
                                        value={newCate}
                                        changeHandler={(e) => {
                                            setNewCate(e.target.value);
                                        }}
                                    />
                                )}
                                <button
                                    onClick={() => {
                                        if (addCate === false) {
                                            setAddCate((prev) => !prev);
                                        } else {
                                            if (newCate.trim() !== '') {
                                                setOptions((prev) => [
                                                    ...prev,
                                                    { name: newCate, value: newCate.toLocaleLowerCase() },
                                                ]);
                                                setNewCate('');
                                            }
                                            setAddCate((prev) => !prev);
                                        }
                                    }}
                                    className="btn-orange"
                                >
                                    {addCate ? 'Add' : 'Add a Category'}
                                </button>
                            </div>
                        </div>

                        <LabeledInput
                            name="Product Name"
                            value={name}
                            changeHandler={(e) => {
                                setname(e.target.value);
                            }}
                            label={'Product Name'}
                        />

                        <div>
                            <MultipleSelect
                                options={[
                                    'Screen Print Design',
                                    'Sublimation Print Design',
                                    'Digital print design',
                                    'Vinyl Printing',
                                    'UV printing',
                                ]}
                                value={printTypes}
                                changeHandler={(value) => {
                                    setPrintTypes(value);
                                }}
                                label="Printing Type(s)"
                            />
                        </div>
                    </div>
                    <div className="add_product_container_description">
                        {mode === 'edit' ? (
                            <LabeledInput
                                name="Edit Note"
                                value={edit}
                                changeHandler={(e) => {
                                    setEdit(e.target.value);
                                }}
                                label={'Edit Note'}
                            />
                        ) : (
                            <LabeledInput
                                name="Product Description"
                                value={description}
                                changeHandler={(e) => {
                                    setDescription(e.target.value);
                                }}
                                label={'Product Description'}
                            />
                        )}
                    </div>
                    {printTypes.length > 0 ? <Pricing types={[...printTypes]} /> : <></>}
                    <div className="add_product_container_design">
                        <div className="add_product_container_design_left">
                            {Object.keys(imagesTypes).map((ele, i) => {
                                return (
                                    <div key={i} className="add_product_container_design_image_add">
                                        <p>{`Add Image of ${imagesTypes[ele].name}`}</p>
                                        <label htmlFor={ele}>
                                            <input
                                                onChange={(e) => {
                                                    imageChangehandler(ele, e.target.files[0]);
                                                }}
                                                id={ele}
                                                className="add_image_input_addproduct"
                                                type="file"
                                                multiple={false}
                                                accept="image/*"
                                            />
                                            {imagesTypes[ele].value === '' ? (
                                                <AddBoxIcon className="add_product_container_design_image_add_icon" />
                                            ) : (
                                                <CheckCircleIcon className="add_product_container_design_image_added_icon" />
                                            )}
                                        </label>
                                    </div>
                                );
                            })}
                            <div className="addnew_image">
                                {addImage && (
                                    <LabeledInput
                                        name="Image Type"
                                        placeholder="Add Image of "
                                        value={newImage}
                                        changeHandler={(e) => {
                                            setNewImage(e.target.value);
                                        }}
                                    />
                                )}
                                <button
                                    onClick={() => {
                                        if (addImage === false) {
                                            setAddImage((prev) => !prev);
                                        } else {
                                            if (newImage !== '') {
                                                setImagesType((prev) => {
                                                    const old = { ...prev };
                                                    old[newImage.replace(/\s/g, '')] = {
                                                        name: newImage,
                                                        value: '',
                                                    };
                                                    return old;
                                                });
                                                setNewImage('');
                                            }
                                            setAddImage((prev) => !prev);
                                        }
                                    }}
                                    style={{ textAlign: 'center !important' }}
                                    className="btn-orange"
                                >
                                    <ImageIcon className="btn-icon" />
                                    <p>ADD ANOTHER IMAGE TYPE</p>
                                </button>
                            </div>
                        </div>
                        <div className="add_product_container_design_right">
                            <div className="add_product_container_design_right_1">
                                <div className="addproduct_sizez_contents">
                                    <div className="home_head">
                                        <h2 className="home_heading">Product Variation:</h2>
                                    </div>
                                    <input
                                        style={{ margin: 'auto', marginTop: '1rem' }}
                                        className="free-flow-input"
                                        value={sizes}
                                        onChange={freeFlowTextHandler}
                                    />
                                    <button
                                        onClick={onConfirmSizeHandler}
                                        style={{ margin: 'auto', marginTop: '1rem' }}
                                        className="btn-orange"
                                    >
                                        Save
                                    </button>
                                </div>
                                {Object.keys(sizesDescription).map((ele, topi) => {
                                    return (
                                        <div key={topi} className="addproduct_sizez_types">
                                            <div className="home_head">
                                                <h2 className="home_heading">{ele}</h2>
                                            </div>
                                            <div>
                                                {sizesDescription[ele].map((color, i) => {
                                                    return (
                                                        <div className="addproduct_sizez_types-colors" key={i}>
                                                            <div>
                                                                <div>
                                                                    <p className="addproduct_sizes_types_title">
                                                                        Color:{' '}
                                                                    </p>
                                                                    <label
                                                                        className="color_select_outer"
                                                                        htmlFor={`${ele}-color-${i}`}
                                                                    >
                                                                        <p
                                                                            className="color_select_label"
                                                                            style={{ backgroundColor: color.color }}
                                                                        ></p>
                                                                        <input
                                                                            onChange={(e) => {
                                                                                onSizeDescrioptionChange(
                                                                                    ele,
                                                                                    i,
                                                                                    'color',
                                                                                    e.target.value
                                                                                );
                                                                            }}
                                                                            id={`${ele}-color-${i}`}
                                                                            type="color"
                                                                            className="color-selector-hidden"
                                                                        />
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <p className="addproduct_sizes_types_title">
                                                                        Material:{' '}
                                                                    </p>

                                                                    <MultipleSelect
                                                                        id={ele + 'material - ' + i}
                                                                        value={[...Object.keys(color.material)]}
                                                                        changeHandler={(value) => {
                                                                            onSizeDescrioptionChange(
                                                                                ele,
                                                                                i,
                                                                                'material',
                                                                                value
                                                                            );
                                                                        }}
                                                                        options={[...typesOfMaterial]}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {Object.keys(color.material).map((element, elementi) => {
                                                                return (
                                                                    <div>
                                                                        <p className="add_product_container_design_material">
                                                                            {element}
                                                                        </p>
                                                                        <div>
                                                                            <p className="addproduct_sizes_types_title">
                                                                                Unit(s):{' '}
                                                                            </p>

                                                                            <LabeledInput
                                                                                style={{ width: '100%' }}
                                                                                changeHandler={(e) => {
                                                                                    onSizeDescrioptionChange(
                                                                                        ele,
                                                                                        i,
                                                                                        'qty',
                                                                                        e.target.value,
                                                                                        element
                                                                                    );
                                                                                }}
                                                                                name={ele + 'units - ' + elementi}
                                                                                value={color.material[element].units}
                                                                            />
                                                                        </div>

                                                                        <div>
                                                                            <p className="addproduct_sizes_types_title">
                                                                                Price(₹):{' '}
                                                                            </p>
                                                                            <LabeledInput
                                                                                style={{ width: '100%' }}
                                                                                name={ele + 'price - ' + elementi}
                                                                                value={color.material[element].price}
                                                                                changeHandler={(e) => {
                                                                                    onSizeDescrioptionChange(
                                                                                        ele,
                                                                                        i,
                                                                                        'price',
                                                                                        e.target.value,
                                                                                        element
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            {color.material.length === 0 && (
                                                                <p className="select_box_comp_comp_input">
                                                                    Select Material(s) of this Color And Size
                                                                </p>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <button
                                                onClick={() => {
                                                    handleAddMore(ele);
                                                }}
                                                style={{ margin: 'auto', marginBottom: '2rem' }}
                                                className="btn-orange"
                                            >
                                                Add More
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="add_product_container_design_right_2">
                                <p className="add_product_container_design_material">Material Types: </p>
                                <div className="add_product_container_design_material_types">
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Polyester"
                                        value="Polyester"
                                        labeling="Polyester"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Cotton"
                                        value="Cotton"
                                        labeling="Cotton"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Supima Cotton"
                                        value="Supima Cotton"
                                        labeling="Supima Cotton"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Ceramic Mug"
                                        value="Ceramic Mug"
                                        labeling="Ceramic Mug"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Polymer Mug"
                                        value="Polymer Mug"
                                        labeling="Polymer Mug"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="MDF"
                                        value="MDF"
                                        labeling="MDF"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Acrylic"
                                        value="Acrylic"
                                        labeling="Acrylic"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Polymer Keychain"
                                        value="Polymer Keychain"
                                        labeling="Polymer Keychain"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Lanyard Keychain"
                                        value="Lanyard Keychain"
                                        labeling="Lanyard Keychain"
                                        checked={false}
                                    />
                                    <CheckBox
                                        handleChange={materialCheckhandler}
                                        name="Other"
                                        value="Other"
                                        labeling="Other"
                                        checked={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="add_product_foot">
                        <button style={{ marginTop: '2rem' }} className="btn-orange">
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
